import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=ca14b480&scoped=true"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"
import style0 from "./Buy.vue?vue&type=style&index=0&id=ca14b480&prod&lang=scss&scoped=true"
import style1 from "./Buy.vue?vue&type=style&index=1&id=ca14b480&prod&lang=scss"
import style2 from "./Buy.vue?vue&type=style&index=2&id=ca14b480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca14b480",
  null
  
)

export default component.exports